<script setup>
const props = defineProps({
  content: {
    type: Object,
    required: true,
  },
  onClicked: {
    type: Function,
    required: true,
  },
  currentSection: {
    type: String,
    default: '',
  },
  isSelected: {
    type: Boolean,
    default: false,
  },
  resumeLanguage: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <div class="experience experience-context" :class="content.indentation ? content.indentation : 'none'">
    <div class="date" :class="{ selected: isSelected && currentSection === 'date' }" @click="onClicked('date')">
      {{ content.date }}
    </div>
    <div class="timeline" />
    <div class="data">
      <div
        class="section job"
        :class="{
          selected: isSelected && (currentSection === 'job' || currentSection === 'client'),
        }"
        @click="onClicked('job')"
      >
        <span v-if="content.job" class="subtitle">poste :</span>
        <span v-if="content.job" class="text">{{ content.job }}</span>
        <span v-if="content.job && content.client" class="spacer" />
        <div
          class="date secondary"
          :class="{ selected: isSelected && currentSection === 'date' }"
          @click="onClicked('date')"
        >
          {{ content.date }}
        </div>
        <span class="client">
          {{ content.client }}
        </span>
      </div>
      <div class="date third" :class="{ selected: isSelected && currentSection === 'date' }" @click="onClicked('date')">
        {{ content.date }}
      </div>
      <div
        v-if="content.info"
        class="section info"
        :class="{ selected: isSelected && currentSection === 'info' }"
        @click="onClicked('info')"
      >
        <span class="subtitle">{{ $t(`resume.sections.${resumeLanguage}.common-context`) }}</span>
        <span v-html="content.info" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.subtitle {
  text-transform: uppercase;
  color: var(--color1);
  font-weight: 700;

  &:last-child {
    margin-top: 1rem;
  }
}

.section {
  &.job {
    margin: 0;
  }
}

.section,
.date {
  &.secondary,
  &.third {
    display: none;
  }
  &:hover,
  &.selected {
    background-color: #fff9ef;
    cursor: pointer;
    border-radius: 12px;
  }
}
</style>
